import React from 'react';
import { motion } from 'framer-motion';
export function TopBanner() {
  const items = ['🔒 Pago 100% seguro MercadoPago', '📩 Acceso inmediato por mail', '💳 3 cuotas sin interés', '🎁 50% OFF por tiempo limitado'];
  const duplicated = [...items, ...items, ...items, ...items];
  return <div className="w-full bg-[#7A4A2B] overflow-hidden py-2.5 pt-[2px] pb-[2px]" data-id="element-248">
      <motion.div className="flex whitespace-nowrap gap-8 pt-[1px] pb-[1px]" animate={{
      x: ['0%', '-50%']
    }} transition={{
      x: {
        repeat: Infinity,
        repeatType: 'loop',
        duration: 10,
        ease: 'linear'
      }
    }} data-id="element-249">
        {duplicated.map((item, index) => <span key={index} className="text-[#FBF5EC] font-semibold text-sm md:text-base flex-shrink-0 px-4" data-id="element-250">
            {item}
          </span>)}
      </motion.div>
    </div>;
}